import tenantUtils from '@utils';
import moment from 'moment';
import { NetworkService } from '../../../../services/networkService';
import { mapQueryParams, openExternal } from '../../../../utility/utility';
import { listingDetailMapper } from '../listings/listingsApis';

const iconMappings = {
  whatsapp: { icon: 'RiWhatsappFill', iconProps: { color: '#25D366', size: '12px' } },
  call: { icon: 'IoCall' },
  email: { icon: 'FaEnvelope' },
  manual: { icon: 'FaHandPointer' },
};

const leadsDataMapper = (data, refsObject) => {
  return data?.map((item) => ({
    client_info: {
      id: item?.client.id,
      leadId: item?.id,
      email: item?.client.email,
      phone: item?.client.mobile,
      whatsapp: item?.client.whatsapp,
      name: tenantUtils.getLocalisedString(item?.client, 'name'),
      created_at: item?.created_at,
      managedBy: item?.user?.name,
    },

    last_interaction: {
      ...iconMappings?.[item?.interest?.source],
      sourceTitle: tenantUtils.getLocalisedString(item?.interest, 'source_title'),
      type: item?.interest?.source,
      content: tenantUtils.getLocalisedString(item?.interest, 'message_body'),
      date: item?.interest?.recorded_at,
      recording_uuid: item?.interest?.recording_url,
      callStatus: item?.interest?.call_status,
    },

    listing_detail: {
      ...listingDetailMapper(item?.interest?.listing),
      clientId: item?.client.id,
      leadId: item?.id,
      interests_count: item?.listings_count,
      interestId: item?.interest?.id,
      userId: item?.user?.id,
    },

    actions: {
      id: item?.id,
      buttonProps: { size: 'small', iconSize: '1em' },
      actionsList: [
        {
          iconType: 'email',
          title: 'Email',
          onClick: () => {
            openExternal(item?.client.email, 'email');
          },
          disabled: !item?.client.email,
        },
        {
          iconType: 'phone',
          title: 'Call',
          onClick: () => {
            openExternal(item?.client.mobile, 'phone');
          },
          disabled: !item?.client.mobile,
        },
        {
          iconType: 'whatsapp',
          style: { color: '#25D366' },
          iconColor: '#25D366',
          title: 'Whatsapp',
          onClick: () => {
            openExternal(item?.client.whatsapp, 'whatsapp');
          },
          disabled: !item?.client.whatsapp,
        },
        {
          iconType: 'add-task',
          title: 'Add Task',
          onClick: (leadId) => {
            refsObject?.['add-task']?.current?.openDrawer(leadId);
          },
        },
      ],
    },

    tasks_detail: {
      parentTask: {
        title: item?.task?.task_purpose?.name,
        title_l1: item?.task?.task_purpose?.name_l1,
        date: item?.task?.completed_at,
        agent_name: item?.task?.assignee?.name,
        agent_name_l1: item?.task?.assignee?.name_l1,
      },
      childTask: item?.task?.child?.id && {
        title: item?.task?.child?.task_purpose?.name,
        title_l1: item?.task?.child?.task_purpose?.name_l1,
        date: item?.task?.child?.created_at,
        isOverdue: item?.task?.child?.due_date ? moment(item.task.child.due_date).isBefore(moment()) : false,
      },
    },
  }));
};

export const getLeadsData = async (params, filtersList, refsObject) => {
  const mappedParams = mapQueryParams(params, filtersList);
  const response = await NetworkService.get(`/api/lms/leads?${mappedParams}`);
  if (response?.error) {
    return response;
  } else {
    return {
      list: leadsDataMapper(response?.data?.leads, refsObject),
      pagination: tenantUtils.getPaginationObject(response?.data?.pagination),
    };
  }
};
